import * as React from 'react';

import BicycleNumber from '@/components/elements/Icon/BicycleNumber';
import { EntryRacer } from '@/lib/apollo/types/gen/graphql';

import { Wrapper } from '../style';

interface RaceResultProps {
  entryRacers: EntryRacer[];
}

const RaceResult: React.FC<RaceResultProps> = React.memo(({ entryRacers }) => {
  const bicycleNums = entryRacers
    .filter(er => er.arrivalOrder === 1)
    .map(er => er.bicycleNum);

  if (!bicycleNums.length) {
    return <>不成立</>;
  }

  return (
    <Wrapper>
      {bicycleNums.map((num, i) => (
        <BicycleNumber
          bicycleNum={num}
          size={['20px', '24px', '32px', '32px']}
          key={`chariloto-dokant7-result-${i}`}
        >
          {num}
        </BicycleNumber>
      ))}
    </Wrapper>
  );
});

export default RaceResult;
